/**
 * Adminページへのアクセスがルーム作成直後かどうかを判定
 * @param id ルームID
 * @returns
 */
export const judgeShowLaunchScreen = (id: string) => {
  const isLaunch = sessionStorage.getItem(`isLaunch${id}`);
  if (isLaunch) {
    sessionStorage.removeItem(`isLaunch${id}`);
    return true;
  } else {
    return false;
  }
};

/**
 * 入力試行回数の上限を超えているかどうか判定
 * @param maxTypeCnt 入力試行回数上限
 * @returns 上限を超えている場合はtrue
 */
export const isExceedRetryTypeCnt = (maxTypeCnt: number) => {
  let retryTypeCnt = sessionStorage.getItem('retryTypeCnt') || 0;
  retryTypeCnt = Number(retryTypeCnt) + 1;
  sessionStorage.setItem('retryTypeCnt', String(retryTypeCnt));
  return retryTypeCnt > maxTypeCnt;
};

export const removeInviteQuery = (url: string) => {
  // 招待URLの「?p=xxxx」を取り除いたもの現在のURLに置き換える
  const replacedInviteUrl = url.replace(/p=[^&]+/, '');
  return replacedInviteUrl.replace('?&', '?').replace(/\?$/, '');
};

export const isPWAuthenticated = (
  route: any,
  roomId: string,
  roomPW: string
) => {
  // キャッシュを確認
  const cachedPW = sessionStorage.getItem(`p${roomId}`);
  if (cachedPW === roomPW) {
    return true;
  }

  // PW入力不要なURLか確認
  const passwordQuery = route?.query?.p;

  // 招待URLではない場合
  if (!passwordQuery) return false;

  if (passwordQuery === roomPW) {
    // PWキャッシュ（次回以降認証済みにするため）
    sessionStorage.setItem(`p${roomId}`, passwordQuery);

    // 招待URLを通常URLに置き換える
    location.href = removeInviteQuery(location.href);

    return true;
  }

  return false;
};

export const getPostTime = (t: any) => {
  let date;
  // Timestampの場合
  if (typeof t === 'object') {
    if ('seconds' in t) {
      date = new Date(t.seconds * 1000);
    } else {
      date = t.toDate();
    }
  } else {
    date = t;
  }

  return date;
};
